import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { ShoppingBag, Menu, X, User } from "lucide-react";
import { useCart } from "../context/CartContext";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/products", label: "Shop Products" },
  { to: "/benefits", label: "Health Benefits" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const { count, setDrawerOpen } = useCart();
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-[#08080A]/80 backdrop-blur-xl" data-testid="main-nav">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 sm:px-8">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-logo">
          <img src="/assets/logo.webp" alt="Alpha Peps logo" className="h-9 w-auto" />
          <span className="hidden font-display text-lg font-extrabold tracking-[0.25em] text-white sm:inline">
            ALPHA<span className="text-[#E8E9EB]">PEPS</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `font-mono text-[11px] tracking-[0.2em] transition-colors duration-200 ${
                  isActive ? "text-[#E8E9EB]" : "text-slate-400 hover:text-white"
                }`
              }
            >
              {l.label.toUpperCase()}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate("/products")}
            data-testid="quick-order-cta"
            className="hidden rounded-full border border-[#6E7683]/60 px-4 py-1.5 font-mono text-[11px] tracking-[0.15em] text-[#E8E9EB] transition-colors duration-200 hover:bg-[#6E7683]/20 md:block"
          >
            QUICK ORDER
          </button>
          <button
            onClick={() => navigate("/products")}
            data-testid="mobile-shop-cta"
            className="rounded-full border border-[#6E7683]/60 px-4 py-1.5 font-mono text-[11px] tracking-[0.15em] text-[#E8E9EB] transition-colors duration-200 hover:bg-[#6E7683]/20 md:hidden"
          >
            SHOP
          </button>
          <button
            onClick={() => navigate("/account")}
            data-testid="account-link"
            title="My account"
            className="rounded-full border border-white/10 p-2.5 text-slate-300 transition-colors duration-200 hover:border-[#E8E9EB]/50 hover:text-white"
          >
            <User className="h-4 w-4" />
          </button>
          <button
            onClick={() => setDrawerOpen(true)}
            data-testid="cart-drawer-trigger"
            className="relative rounded-full border border-white/10 p-2.5 text-slate-300 transition-colors duration-200 hover:border-[#E8E9EB]/50 hover:text-white"
          >
            <ShoppingBag className="h-4 w-4" />
            {count > 0 && (
              <span data-testid="cart-count-badge" className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-[#6E7683] font-mono text-[10px] font-bold text-white">
                {count}
              </span>
            )}
          </button>
          <button
            onClick={() => setMobileOpen((o) => !o)}
            data-testid="mobile-menu-toggle"
            className="rounded-full border border-white/10 p-2.5 text-slate-300 md:hidden"
          >
            {mobileOpen ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <nav className="border-t border-white/10 bg-[#08080A]/95 px-5 py-4 backdrop-blur-xl md:hidden" data-testid="mobile-nav-menu">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => setMobileOpen(false)}
              data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="block py-3 font-mono text-xs tracking-[0.2em] text-slate-300 hover:text-[#E8E9EB]"
            >
              {l.label.toUpperCase()}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
};
